export default {
  index:'首页',
  majorsys:'主要系统',
  platform:'专业平台',
  miniapp:'小程序',
};
